import { Button, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { fetchCounter, fetchProverb } from '../reducks/mainPage/operations';
import { useDispatch, useSelector } from 'react-redux';
import { getCounter, getProverb } from '../reducks/mainPage/selectors';
import { useHistory } from 'react-router';
import CleanPlaces from './CleanPlaces';
import { CleaningCounter } from '../components';
import {signOut} from '../reducks/users/operations'

/**
 * Styleの定義
 */
const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paperHeader: {
        padding: theme.spacing(1),
        textAlign: 'center',
        fontWeight: 'bold',
        color: theme.palette.text.secondary,
    },
    paperBody: {
        padding: theme.spacing(1),
        textAlign: 'left',
        color: theme.palette.text.secondary,
    },
    paperFooter: {
        padding: theme.spacing(1),
        textAlign: 'right',
        color: theme.palette.text.secondary,
    },
    button: {
        color: theme.palette.text.secondary,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    signOutButton: {
        color: theme.palette.text.secondary,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    }
}));
  
const LoginedMainPage = () => {

    // Styleの読み込み
    const classes = useStyles();
    // Reduxとの連携
    const dispatch = useDispatch();
    const selector = useSelector(state => state);
    const todayProverb = getProverb(selector);
    const userCounter = getCounter(selector);

    // 画面遷移系
    const history = useHistory()

    // useEffectの第二引数に関して（https://qiita.com/k-penguin-sato/items/9373d87c57da3b74a9e6）
    useEffect(() => {
        dispatch(fetchProverb())
        dispatch(fetchCounter())
    }, []);

    
    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Button variant="contained" className={classes.button} onClick={() => history.push("CleaningPlaces")}>
                            掃除する場所を決める
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <CleaningCounter counter={userCounter}/>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={6}>
                <Grid style={{height: "100%"}}>
                    <Paper variant="outlined" style={{ height: "100%" }}>
                        <Typography variant="h6" className={classes.paperHeader}>今日の格言</Typography>
                        <Typography variant="body2" className={classes.paperBody}>{todayProverb.content}​</Typography>
                        <Typography variant="body2" className={classes.paperFooter}>{todayProverb.author}</Typography>
                    </Paper>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Button variant="contained" className={classes.signOutButton} onClick={() => dispatch(signOut())}>
                    サインアウト
                </Button>
            </Grid>
            {/* TODO:ログイン機能ができたら『アプリの使い方』を実装する */}
            {/* <Grid item xs={12}>
                <Paper variant="outlined" className={classes.paper}>
                    <Typography variant="h6">このアプリの使い方</Typography>
                </Paper>
            </Grid> */}
        </Grid>        
    )
}

export default LoginedMainPage;
